import { render, staticRenderFns } from "./donate.vue?vue&type=template&id=6afebada&"
import script from "./donate.vue?vue&type=script&lang=js&"
export * from "./donate.vue?vue&type=script&lang=js&"
import style0 from "./donate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports